import { Event, EventDate } from '@domain/events/models/Event';
import { EventDTO, EventDateDTO } from '../dto/EventDTO';

export class EventMapper {
  static toModel(dto: EventDTO): Event {
    return {
      id: dto.id,
      title: dto.title,
      companyId: dto.companyId,
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt),
      eventDates: dto.eventDates.map(EventMapper.eventDateToModel)
    };
  }

  static toDTO(model: Event): EventDTO {
    return {
      id: model.id,
      title: model.title,
      companyId: model.companyId,
      createdAt: model.createdAt.toISOString(),
      updatedAt: model.updatedAt.toISOString(),
      eventDates: model.eventDates.map(EventMapper.eventDateToDTO)
    };
  }

  static eventDateToModel(dto: EventDateDTO): EventDate {
    return {
      id: dto.id,
      eventId: dto.eventId,
      date: new Date(dto.date),
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt)
    };
  }

  static eventDateToDTO(model: EventDate): EventDateDTO {
    return {
      id: model.id,
      eventId: model.eventId,
      date: model.date.toISOString().split('T')[0], // Format as YYYY-MM-DD
      createdAt: model.createdAt.toISOString(),
      updatedAt: model.updatedAt.toISOString()
    };
  }
}

